import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Escena1 from "../../../images/modulo14/escena1.png";
import Escena2 from "../../../images/modulo14/escena2.png";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad2Actividad1.mp3";

const Actividad2 = () => {
  const infoUnidad = modulo14.content[1];
  const infoAct = modulo14.content[1].activities[0];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[1].name}: ${modulo14.content[1].activities[1].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[1].path}`,
    titlePrev: `${modulo14.content[0].name}: ${modulo14.content[0].activities[11].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[11].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>Observa las escenas a continuación y lee los diálogos.</li>
      </ul>
      <div className="row ps-5 my-4">
        <div className="col-12">
          <p>
            <strong>Escena 1</strong>
          </p>
          <img src={Escena1} className="img-fluid" alt="Escena1" />
          <p className="mt-5">
            <strong>Escena 2</strong>
          </p>
          <img src={Escena2} className="img-fluid" alt="Escena2" />
        </div>
      </div>
      <li className="mb-4 mt-5">
        Ahora piensa y con ayuda de tu profesor, profesora o familiar, responde
        las siguientes preguntas:{" "}
      </li>
      <div className="col-md-10 col-12">
        <p>¿Qué sucede en cada una de las escenas?</p>
        <textarea className="form-control mb-4" rows={3} />
        <p>¿Por qué crees que los amigos de Eli no entienden lo que dice? </p>
        <textarea className="form-control mb-4" rows={3} />

        <p>¿Por qué Eli no entiende lo que dice Pepe Murakami?</p>
        <textarea className="form-control mb-4" rows={3} />
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que en esta unidad se busca trabajar
            sobre la llegada del castellano al Perú y sus variedades existentes.
            Para ello, se hará énfasis en la deliberación. Es decir, el niña o la niña reflexionará a partir de la información con el fin de
            formar sus propias opiniones. Las actividades que se trabajarán en
            esta sesión buscan dar información detallada a partir de la
            observación de imágenes.
          </li>
          <li>
            Lea la primera indicación: Observa las escenas a continuación y lee
            los diálogos. Pida a una niña y un niño que lean en voz alta el
            primer y el segundo diálogo. Lea la segunda indicación: Ahora piensa
            y conversa con tu profesor, profesora o familiar sobre lo siguiente:
            - ¿Qué sucede en cada una de las escenas? - ¿Por qué crees que los
            amigos de Eli no entienden lo que dice? - ¿Por qué Eli no entiende
            lo que dice Pepe Murakami?
          </li>
          <li>
            Aclare que en la primera imagen aparece Eli Páucar
            con unos niños y, en la segunda imagen, los personajes son Eli
            Páucar y Pepe Murakami. Déles un tiempo para que trabajen
            individualmente. Retome las respuestas a cada una
            de las preguntas:
            <ul>
              <li>
                <i>
                  “¿Qué sucede en cada una de las escenas? (Posible respuesta:
                  En la primera escena, Eli les está contando a sus amigos que
                  su hermano se ha hecho una herida. Mientras lo cuenta, utiliza
                  una palabra, “jalachaqui”, que sus amigos no entienden. En la
                  segunda escena, Pepe Murakami conversa con Eli sobre sus
                  mangos pero utiliza una palabra, “macanudos”, que Eli no
                  entiende).
                </i>
              </li>
              <li>
                <i>
                  ¿Por qué creen que los amigos de Eli no entienden lo que dice?
                  (Posible respuesta: “Jalachaqui” es una palabra que viene del
                  quechua y significa descalzo. Se usa en zonas donde se habla
                  quechua (Eli es de Ayacucho). Los amigos de Eli tal vez no
                  tienen esa palabra en su vocabulario).
                </i>
              </li>
              <li>
                <i>
                  “¿Por qué Eli no entiende lo que dice Pepe Murakami? (Posible
                  respuesta: Eli no entiende cuando Pepe Murakami le dice
                  “macanudo” porque es una palabra que ya no se usa mucho. Es
                  usada sobre todo por personas que pertenecen a una generación
                  mayor”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
